<template>
    <div class="login-container">
        <el-form class="card-box login-form" autoComplete="on" :model="ruleForm" :rules="rules" ref="ruleForm"
                 label-position="left">
            <h3 class="title">选品库</h3>
            <el-form-item prop="username" class="item">
                <el-input
                    placeholder="用户名"
                    name="userName"
                    autoComplete="on"
                    v-model="ruleForm.userName">
                    <i slot="prefix" class="el-input__icon"><icon-svg icon-class="user"/></i>
                </el-input>
            </el-form-item>
            <el-form-item prop="password" class="item item_pwd">
                <!--<span class="svg-container">-->
                <!--<icon-svg icon-class="pwd"/>-->
                <!--</span>-->
                <el-input
                    placeholder="密码"
                    name="pwd"
                    @keyup.enter.native="handleLogin"
                    v-model="ruleForm.pwd"
                    show-password
                    autoComplete="on">
                    <i slot="prefix" class="el-input__icon"><icon-svg icon-class="pwd"/></i>
                    <!-- <i slot="suffix" class="el-input__icon" @click='isShowPwd = !isShowPwd'><icon-svg icon-class="eye"/></i> -->
                </el-input>
            </el-form-item>
            <div>
                <el-button type="primary" style="width:100%;margin-bottom:8px;" :loading="loading" @click.native="handleLogin()">登录
                </el-button>
<!--                <span class="register" @click="register">注册</span>-->
<!--                <span class="forget" @click="forget">忘记密码</span>-->
            </div>
            <!-- <div>
                <span class="forget" style="color: rgb(133, 183, 255);" @click="onuserProtocol">《用户服务协议》</span>
            </div> -->
            <!-- <div>
                <el-button type="primary" style="width:100%;margin-bottom:30px;"
                           @click='showDialog = true'>
                    第三方登录
                </el-button>
            </div> -->
        </el-form>

        <div>
            <a href="https://beian.miit.gov.cn/" target="_blank" style="display: block;color: red;position: absolute;bottom: 20px;left: 920px">备案号:闽ICP备2022009993号</a>
        </div>

        <el-dialog title="第三方验证" :visible.sync="showDialog">
            邮箱登录成功,请选择第三方验证<br/>
        </el-dialog>
        <register :visible="ctrl.registerVisible" :title="ctrl.dialogTitle" @close-callback="closeCllback"></register>
        <forget :visible="ctrl.forgetVisible" :title="ctrl.dialogTitle" @close-callback="closeCllback"></forget>
    </div>
</template>

<script>
import Register from "./register";
import Forget from "./forget";
export default {
    components: { Register, Forget },
    data() {
        let validatePwd = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请输入密码"));
            } else {
                callback();
            }
        };
        return {
            ctrl: {
                registerVisible: false,
                settingVisible: false,
                forgetVisible: false
            },
            ruleForm: {
                userName: "",
                pwd: "",
                checked: true
            },
            rules: {
                userName: [
                    { required: true, message: "请输入登录名", trigger: "blur" }
                ],
                pwd: [{ validator: validatePwd, trigger: "blur" }]
            },
            formData: {},
            isShowPwd: false, // 是否显示密码
            loading: false, // 登录loading
            showDialog: false, // 显示dialog
            redirect: null // 回调地址
        };
    },
    methods: {
        //注册
        register() {
            this.ctrl.registerVisible = true;
            this.ctrl.dialogTitle = "注册";
        },
        //忘记密码
        forget() {
            this.ctrl.forgetVisible = true;
            this.ctrl.dialogTitle = "忘记密码";
        },
        // 关闭弹窗回调
        closeCllback() {
            this.ctrl.registerVisible = false;
            this.ctrl.settingVisible = false;
            this.ctrl.forgetVisible = false;
        },
        handleLogin() {
            this.$refs["ruleForm"].validate(valid => {
                if (valid) {
                    if (this.ruleForm.userName.length == 0) {
                        this.$message({
                            type: "error",
                            message: "请输入用户名"
                        });
                        return;
                    }
                    if (this.ruleForm.pwd.length == 0) {
                        this.$message({
                            type: "error",
                            message: "请输入密码"
                        });
                        return;
                    }
                    if (this.ruleForm.pwd.length < 3) {
                        this.$message({
                            type: "error",
                            message: "请输入不小于3位数的密码"
                        });
                        return;
                    }
                    this.loading = true;
                    this.$store
                        .dispatch("loginName", this.ruleForm)
                        .then(response => {
                            this.loading = false;
                            if (response.code) {
                                return;
                            }
                            let path = "/";
                            // if (this.redirect) {
                            //     path = this.redirect;
                            // }
                            // this.$router.push({
                            //     path: path
                            // });
                            window.location.replace(path);
                        })
                        .catch(() => {
                            this.loading = false;
                        });
                } else {
                    return false;
                }
            });
        }
    },
    created() {
        // 将参数拷贝进查询对象
        let query = this.$route.query;
        if (query.redirect) {
            // URL Encode
            this.redirect = decodeURIComponent(query.redirect);
        }
    }
};
</script>

<style type="text/scss" lang="scss" scoped>
@import "../../styles/mixin";

$bg: #2d3a4b;
$dark_gray: #889aa4;
$light_gray: #eee;
.register {
    color: #fff;
    margin: 0 auto;
}
.forget {
    color: #fff;
    margin: 0 auto;
    float: right;
}
.userProtocol {
    color: rgb(133, 183, 255);
}
.userProtocol:hover {
    cursor: pointer;
    text-decoration: underline;
}
.register:hover {
    cursor: pointer;
    text-decoration: underline;
    color: #0bb8e3;
}
.forget:hover {
    cursor: pointer;
    text-decoration: underline;
    color: #0bb8e3;
}
.login-container {
    @include relative;
    height: 100%;
    background-color: $bg;
    input:-webkit-autofill {
        -webkit-box-shadow: 0 0 0 1000px #293444 inset !important;
        -webkit-text-fill-color: #fff !important;
    }
    .item {
        .el-form-item__content {
            display: flex;
            flex-flow: row;
        }
    }
    input {
        background: transparent;
        border: 0;
        -webkit-appearance: none;
        border-radius: 0;
        padding: 0.46rem 0.0666rem 0.16rem 0.2rem;
        color: $light_gray;
        height: 100%;
    }
    .el-input {
        display: inline-block;
    }
    .tips {
        font-size: 14px;
        color: #fff;
        margin-bottom: 0.13333rem;
    }
    .svg-container {
        padding: 0.08rem 0.0666rem 0.08rem 0.2rem;
        color: $dark_gray;
        vertical-align: middle;
        display: inline-block;
        &_login {
            font-size: 20px;
        }
    }
    .title {
        font-size: 26px;
        color: $light_gray;
        margin: 0 auto 0.5333rem auto;
        text-align: center;
        font-weight: bold;
    }
    .login-form {
        @include fxied-center;
        top: 40%;
        width: 22em;
        padding: 0.4666rem 0.4666rem 0.2rem 0.4666rem;
    }
    .el-form-item {
        border: 1px solid rgba(255, 255, 255, 0.1);
        background: rgba(0, 0, 0, 0.1);
        border-radius: 0.0666rem;
        color: #454545;
    }
    .show-pwd {
        position: absolute;
        right: 0.1333rem;
        top: 0.09333rem;
        font-size: 16px;
        color: $dark_gray;
        cursor: pointer;
    }
    .thirdparty-button {
        /*position: absolute;*/
        /*right: .4666rem;*/
        /*bottom: .37333rem;*/
    }
}
.checked_item {
    display: flex;
    justify-content: space-between;
    margin-bottom: 5px;
    align-items: center;
    font-size: 13px;
    color: rgb(70, 67, 67);
}
</style>
